import React, { useState } from "react";
import { T } from "../theme";
import { whenLines, formatStepDate } from "../time";

// A milestone's date, and optionally its time. Click to edit. With a time
// set it shows in every zone the engagement uses (client HQ, then NZ), each
// with its own day. The time is entered in one zone (picked here) and
// stored with it, so it converts correctly through daylight-saving changes.
const field = { fontSize: 12, border: `1px solid ${T.borderSubtle}`, borderRadius: T.radiusSm, padding: "4px 6px", color: T.root, outline: "none", fontFamily: T.fontSans };

export default function EditableWhen({ value, zones, onChange }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(null);
  const open = () => {
    setDraft({ date: value.date || new Date().toLocaleDateString("en-CA"), time: value.time || "", endTime: value.endTime || "", tz: value.tz || zones[0].tz });
    setEditing(true);
  };
  const save = () => {
    if (!draft.date) { setEditing(false); return; }
    onChange(draft.time ? { date: draft.date, time: draft.time, endTime: draft.endTime || undefined, tz: draft.tz } : { date: draft.date, time: undefined, endTime: undefined, tz: undefined });
    setEditing(false);
  };
  const key = e => { if (e.key === "Enter") save(); if (e.key === "Escape") setEditing(false); };

  if (editing) {
    return (
      <div data-when-editor style={{ display: "flex", flexWrap: "wrap", gap: 6, alignItems: "center", justifyContent: "flex-end" }} onKeyDown={key}>
        <input aria-label="Date" type="date" autoFocus value={draft.date} onChange={e => setDraft(d => ({ ...d, date: e.target.value }))} style={{ ...field, borderColor: T.threadline }} />
        <input aria-label="Start time" type="time" value={draft.time} onChange={e => setDraft(d => ({ ...d, time: e.target.value }))} style={field} />
        <span style={{ fontSize: 11, color: T.fgMuted }}>to</span>
        <input aria-label="End time" type="time" value={draft.endTime} disabled={!draft.time} onChange={e => setDraft(d => ({ ...d, endTime: e.target.value }))} style={field} />
        {zones.length > 1 && (
          <select aria-label="Time zone" value={draft.tz} onChange={e => setDraft(d => ({ ...d, tz: e.target.value }))} style={field}>
            {zones.map(z => <option key={z.tz} value={z.tz}>{z.label} time</option>)}
          </select>
        )}
        <button onClick={save} style={{ padding: "4px 10px", fontSize: 11, fontWeight: 600, color: T.fgOnDark, background: T.root, border: "none", borderRadius: T.radiusSm, cursor: "pointer", fontFamily: T.fontSans }}>Save</button>
        <button onClick={() => setEditing(false)} style={{ padding: "4px 6px", fontSize: 11, color: T.fgMuted, background: "none", border: "none", cursor: "pointer", fontFamily: T.fontSans }}>Cancel</button>
      </div>
    );
  }

  const lines = whenLines(value, zones);
  const link = { cursor: "pointer", borderBottom: `1px dashed ${T.borderSubtle}`, paddingBottom: 1 };
  if (!value.date) return <span onClick={open} title="Set the date" style={{ ...link, fontSize: 11, color: T.borderStrong }}>Set date</span>;
  if (lines.length === 0) return <span onClick={open} title="Change the date or add a time" style={{ ...link, fontSize: 11, color: T.fgSecondary }}>{formatStepDate(value.date)}</span>;
  return (
    <div data-when onClick={open} title="Change the date or time" style={{ cursor: "pointer", display: "inline-flex", flexDirection: "column", gap: 2 }}>
      {lines.map((l, i) => (
        <span key={i} style={{ fontSize: 11, whiteSpace: "nowrap", color: i === 0 ? T.fgSecondary : T.fgMuted, fontWeight: i === 0 ? 600 : 400 }}>
          {l.day} · {l.time}{l.label ? <span style={{ fontWeight: 400, color: T.fgMuted }}> {l.label}</span> : null}
        </span>
      ))}
    </div>
  );
}
